import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useContext } from "react";
import { FormContext } from "../ImsAuditMainstage2";
import * as yup from "yup";
import FormikControl from '../../../../hoc/formikComponents/FormikControl.js'

function BasicInfo2() {
    const { activeStepIndex, setActiveStepIndex, formData, setFormData,
        technicalExpertList, setTechnicalExpertList,
        leadauditorList, setLeadauditorList,
        initialValues, setInitialValues,
        mutationTechnicalExpertDetails, mutationLeadAudiorDetails, mutationAssisAuditorDetails,
        OrgList, mutationgetCompanyDetails,
        saveData, options,
        assitAuditorList, setassitAuditorList,
        OrgListOrg, typeofaddressed, typeofadequate

    } = useContext(FormContext);

    const renderError = (message) => (
        <p className="italic text-red-600">{message}</p>
    );

    const ValidationSchema = yup.object().shape({
        // workspaceName: yup.string().required(),
        // workspaceURL: yup.string().url().required(),
    });

    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const data = { ...formData, ...values };
                saveData(values);
                setActiveStepIndex(activeStepIndex + 1);
            }}>
            <Form className="flex flex-col justify-center items-center">


                <div className="formOuterDiv">
                    <table>
                        <thead>
                            <tr>
                                <th scope="col">Sr.No</th>
                                <th scope="col">Cl.No</th>
                                <th scope="col" width="50%">Documentation Requirements</th>
                                <th scope="col">Adddressed(Yes/No)</th>
                                <th scope="col">Adequate(Yes/No)</th>
                                <th scope="col" width="30%">Remarks / Concern No.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>4.1</td>
                                <td width="50%">
                                    Whether the organization has determined external and internal issues that are relevant to its purpose and :
                                    <li>a.	its strategic direction and that affect its ability to achieve the intended result(s) of its QMS?</li>
                                    <li>b.	that affect its ability to achieve the intended outcome(s) of its EMS?</li>
                                    <li>c.	that affect its ability to achieve the intended outcome(s) of its OHSMS?</li>

                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedone' style={{ textAlign: "center" }} />
                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofadequate} name='typeofadequateone' style={{ textAlign: "center" }} />
                                </td>
                                <td>
                                    <FormikControl control='inputtable' type="text" name='remarkone' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td>2a</td>
                                <td rowSpan="3">4.2</td>
                                <td>
                                Whether the organization has determined the interested parties relevant to its QMS, EMS& OHSMS?

                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedtwo' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatetwo' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                <FormikControl control='inputtable' type="text" name='remarktwo' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td>2b</td>
                               
                                <td>
                                Whether the organization has determined the requirements of these interested parties that are relevant to its QMS, EMS& OHSMS?

                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedtwo1' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatetwo1' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                <FormikControl control='inputtable' type="text" name='remarktwo1' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td>2c</td>
                               
                                <td>
                                Whether the organization has determined the requirements that have become its compliance obligations (legal & other requirements) related to EMS & OHSMS?

                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedtwo2' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatetwo2' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                <FormikControl control='inputtable' type="text" name='remarktwo2' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td>3a</td>
                                <td rowSpan="3">4.3</td>
                                <td>
                                Whether the organization has determined the boundaries and applicability of the QMS, EMS & OHSMS to establish and document its scope? 

                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedthree' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatethree' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                <FormikControl control='inputtable' type="text" name='remarkthree' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td>3b</td>
                                <td>
                                When determining the scope, the organization has considered:
                                <li>i)	the external & internal issues;</li>
                                <li>ii)	the requirements of relevant interested parties (for QMS& OHSMS), the compliance obligations (for EMS) ;</li>
                                <li>iii)	the products and services of the organization (for QMS & EMS), its activities, organizational units, functions and physical boundaries (for EMS);</li>
                                <li>iv)	its authority and ability to exercise control and influence (for EMS); and </li>
                                <li>v)	planned or performed work-related activities (for OHSMS)</li>


                                </td>
                                
                                <td>
                                    <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedthree1' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatethree1' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                <FormikControl control='inputtable' type="text" name='remarkthree1' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td>3c</td>
                               
                                <td>
                               <li> i)	Whether the organization has documented Scope of its QMS, EMS & OHSMS? Whether Scope state the types of products and services covered and provide justification for exclusion of any requirements of ISO 9001?</li>
                               <li> ii)	Whether this scope is available to interested parties (only for EMS)?</li>

                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedthree2' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatethree2' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                <FormikControl control='inputtable' type="text" name='remarkthree2' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                                <td rowSpan="7">4</td>
                                <td rowSpan="7">5.2</td>
                                <td>
                                Whether top management has established, implemented and maintained a documented Management Policy that:
a)	is appropriate to the purpose and context of the organization:
<li>i)	and supports its strategic direction (for QMS),</li>
<li>ii)	including the nature, scale and environmental impacts of its activities, products and services (for EMS)</li>
<li>iii)	is relevant and appropriate to the size and to the specific nature of its OHS risks & OHS opportunities, includes a commitment to provide safe and healthy working conditions for the prevention of work-related injury and ill health (for OHSMS)</li>


                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedfour' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatefour' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                <FormikControl control='inputtable' type="text" name='remarkfour' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                               
                                <td>
                                b)	provides a framework for setting quality, environmental & OHS objectives? 


                                </td>
                                
                                <td>
                                    <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedfour1' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatefour1' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                <FormikControl control='inputtable' type="text" name='remarkfour1' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                              
                               
                                <td>
                                c)	includes a commitment to: 
<li>i)	satisfy applicable requirements (for QMS);</li>
<li>ii)	the protection of the environment, including prevention of pollution and other specific commitment(s) relevant to the context of the organization (for EMS);</li>
<li>iii)	fulfil legal and other requirements (for OHSMS).</li>


                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedfour2' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatefour2' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                <FormikControl control='inputtable' type="text" name='remarkfour2' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                              
                               
                              <td>
                              d)	includes a commitment to:
<li>i)	continual improvement of QMS;</li>
<li>ii)	fulfil its compliance obligations (for EMS);</li>
<li>iii)	eliminate hazards and reduce OHS risks (for OHSMS);</li>



                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedfour3' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatefour3' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                              <FormikControl control='inputtable' type="text" name='remarkfour3' className="form-control" />
                              </td>
                          </tr>
                          <tr>
                              
                               
                              <td>
                              e)	includes a commitment to continual improvement of OHSMS and EMS to enhance 	environmental performance;



                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedfour4' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatefour4' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                              <FormikControl control='inputtable' type="text" name='remarkfour4' className="form-control" />
                              </td>
                          </tr>
                          <tr>
                              
                               
                              <td>
                              f)	includes a commitment to consultation and participation of workers, and, where 	they exist, worker’s representatives (for OHSMS)



                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedfour5' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatefour5' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                              <FormikControl control='inputtable' type="text" name='remarkfour5' className="form-control" />
                              </td>
                          </tr>
                          <tr>
                              
                               
                              <td>
                              Is policy available to interested parties (for EMS), is available to interested parties, as appropriate (for QMS & OHSMS)



                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedfour6' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                                  <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatefour6' style={{ textAlign: "center" }} /> 
                              </td>
                              <td>
                              <FormikControl control='inputtable' type="text" name='remarkfour6' className="form-control" />
                              </td>
                          </tr>
                          <tr>
                              
                               <td>5</td>
                               <td>5.3</td>
                                <td>
                                Whether top management has ensured that the responsibilities and authorities for relevant roles within the OHSMS are assigned and communicated at all levels within the organization and maintained as documented information? (for OHSMS)

                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedfive' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatefive' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                <FormikControl control='inputtable' type="text" name='remarkfive' className="form-control" />
                                </td>
                            </tr>
                            <tr>
                              
                               <td>6</td>
                               <td>6.1.1</td>
                                <td>
                                a)	While planning management system, whether organization has considered:
i)	internal/external issues, requirements of interested parties;
ii)	scope of its EMS & OHSMS; and
b)	b)	Determined and documented (for EMS & OHSMS) the risk and opportunities:
i)	related to its environmental aspects, compliance obligations (for EMS)
ii)	internal/external issues, requirements of interested parties;
iii)	taking into account hazards, OHS risks & other risks, OHS opportunities and other opportunities, legal requirements & other requirements (for OHSMS).


                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofaddressed} name='typeofaddressedsix' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                    <FormikControl control='selecttable' options={typeofadequate} name='typeofadequatesix' style={{ textAlign: "center" }} /> 
                                </td>
                                <td>
                                <FormikControl control='inputtable' type="text" name='remarksix' className="form-control" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="card-footer">
                    <div className="row">
                        <div className="col-sm-1"></div>

                        <div className="col-sm-2">
                            <button type="button" className="btn btn-primary float-left" onClick={() => setActiveStepIndex(activeStepIndex - 1)}>previous</button>
                        </div>
                        <div className="col-sm-7"></div>
                        <div className="col-sm-2">
                            <button type="submit" className="btn btn-primary float-right">Next</button>
                        </div>
                    </div>
                </div>
            </Form>
        </Formik>
    );
}

export default BasicInfo2;